import { ReactComponent as BindBoxIcon } from '@/assets/images/svg/bindbox.svg';
import { ReactComponent as GiftIcon } from '@/assets/images/svg/gift.svg';
import { ReactComponent as MyLazbubuIcon } from '@/assets/images/svg/person.svg';
import Agent from '@/pages/Agent';
import BlindBox from '@/pages/BlindBox';
import Debug from '@/pages/Debug';
import Gift from '@/pages/Gift';
import MyLazbubu from '@/pages/MyLazbubu';
import Lazbubu from '@/pages/Play';
import Share from '@/pages/Share';
import { Redirect } from 'react-router-dom';
export interface RouteConfig {
    path: string;
    component: React.ComponentType;
    name: string;
    exact?: boolean;
}

export const routes: RouteConfig[] = [
    {
        path: '/',
        component: () => <Redirect to="/lazbubu" />,
        exact: true,
        name: 'Lading',
    },
    {
        path: '/lazbubu',
        component: MyLazbubu,
        exact: true,
        name: 'MyLazbubu',
    },
    {
        path: '/agent/:agentId',
        component: Agent,
        exact: true,
        name: 'Agent',
    },

    {
        path: '/blind-box',
        component: BlindBox,
        name: 'BlindBox',
    },

    {
        path: '/gift',
        component: Gift,
        name: 'Gift',
    },
    {
        path: '/lazbubu/:id',
        component: Lazbubu,
        name: 'Lazbubu',
    },
    {
        path: '/share/:id',
        component: Share,
        name: 'Share',
    },
    // Debug route appears only when VITE_TEST is truthy
    ...(import.meta.env.VITE_TEST
        ? ([
              {
                  path: '/debug',
                  component: Debug,
                  name: 'Debug',
              },
          ] as RouteConfig[])
        : ([] as RouteConfig[])),
];

export const NavConfig = [
    {
        label: 'My Lazbubu',
        icon: MyLazbubuIcon,
        path: '/lazbubu',
    },
    {
        label: 'Blind box',
        icon: BindBoxIcon,
        path: '/blind-box',
    },
    {
        label: 'Gift',
        icon: GiftIcon,
        path: '/gift',
    },
    // Conditionally append Debug below Gift when test env is enabled
    // ...(isTestEnv
    //     ? ([
    //           {
    //               label: 'Debug',
    //               icon: DebugIcon,
    //               path: '/debug',
    //           },
    //       ] as const)
    //     : ([] as const)),
] as const;
